export const APPLICATION_USER_ROOT = 'applicationUser/';

// Actions types
export const GET_APPLICATION_USER_INFO = 'getApplicationUserInfo';
export const GET_USER_CONTACT_DETAILS = 'getUserContactDetails';
export const UNLOCK_USER = 'unlockUser';
export const APPLICATION_USER_RESET_PASSWORD = 'resetPassword';
export const UPDATE_USER_CONTACT_DETAILS = 'updateUserContactDetails';

// Mutations types
export const SET_APPLICATION_USER_INFO_ERRORS = 'setApplicationUserInfoErrors';
export const SET_APPLICATION_USER_LOADING = 'setApplicationUserLoading';
export const SET_APPLICATION_USER_SEARCH_OBJECT = 'setApplicationUserSearchObject';
export const SET_USER_INFO_LIST = 'setUserInfoList';
export const SET_USER_ADDITIONAL_INFO_LIST = 'setUserAdditionalInfoList';
export const APPLICATION_USER_RESET_STATE = 'applicationUserResetState';
export const CURRENT_APP_USER_DETAILS = 'currentAppUserDetails';
export const OPEN_CHANGE_APP_USER_DETAILS_MODAL = 'openChangeAppUserDetailsModal';
export const CHANGE_APP_USER_DETAILS_MODAL_ERRORS = 'changeAppUserDetailsModalErrors';

// Getters types
export const APPLICATION_USER_INFO_ERRORS = 'applicationUserInfoErrors';
export const APPLICATION_USER_LOADING = 'applicationUserLoading';
export const APPLICATION_USER_SEARCH_OBJECT = 'applicationUserSearchObject';
export const USER_INFO_LIST = 'userInfoList';
export const USER_ADDITIONAL_INFO_LIST = 'userAdditionalInfoList';
export const SET_CURRENT_APP_USER_DETAILS = 'setCurrentAppUserDetails';
export const SET_OPEN_CHANGE_APP_USER_DETAILS_MODAL = 'setOpenChangeAppUserDetailsModal';
export const SET_CHANGE_APP_USER_DETAILS_MODAL_ERRORS = 'setChangeAppUserDetailsModalErrors';
